import React, { useState } from "react";
import styled from "styled-components";
import CheckIcon from "sweet-web/components/icons/CheckIcon";
import { ItemTitle } from "sweet-web/components/universal/Text";
import { colors } from "sweet-web/lib/styles";

/*
Multi Select Input
Select from a number of options
*/

const Outer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 10px 0 10px 0;
  width: 100%;
`;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
`;

const Option = styled.div<{ checked: boolean }>`
  user-select: none;
  font-size: 14px;
  font-weight: 500;
  color: ${colors.primary};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0 5px 0;
  margin: 3px 0 3px 0;
  flex-basis: 50%;
  /* &:first-of-type {
    margin-top: 0;
    padding-top: 0;
  } */
  &:hover {
    span {
      border-color: ${colors.primary};
    }
  }
  .sweet-multi-select-input-check-icon {
    transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
    opacity: ${props => (props.checked ? 1 : 0)};
  }
`;

const Checkbox = styled.span`
  display: flex;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid ${colors.primary};
  margin-right: 10px;
  justify-content: center;
  align-items: center;
`;

type Props = {
  title?: string;
  value: boolean;
  onChange: (checked: boolean) => void;
  style?: object;
};
const CheckboxInput: React.FC<Props> = props => {
  return (
    <Option
      style={props.style}
      checked={props.value}
      key={`checkbox-option-${props.title}`}
      onClick={() => {
        props.onChange(!props.value);
      }}
    >
      <Checkbox>
        <CheckIcon
          height={10}
          color={colors.primary}
          className="sweet-multi-select-input-check-icon"
        />
      </Checkbox>
      {props.title}
    </Option>
  );
};
CheckboxInput.defaultProps = {
  style: {}
};

export default CheckboxInput;
